import { Component, inject } from '@angular/core';
import { PojavniOblik } from '@app/shared/models/pojavni-oblik';
import {
  ActionComponent,
  ItemInfo,
  ItemViewProviderDirective,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { catchError, finalize, first, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-odabir-pojavnog-za-izlucivanje',
  templateUrl: './odabir-pojavnog-za-izlucivanje.component.html'
})
export class OdabirPojavnogZaIzlucivanjeComponent extends ActionComponent {
  public showDialog = false;

  private itemViewProvider = inject(ItemViewProviderDirective);
  private listviewProvider = inject(ListViewProviderDirective);
  private notificationService = inject(NotificationService);

  public onSelectedItem(jedinice: PojavniOblik[]) {
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          first(),
          switchMap((parent) => {
            return this.listviewProvider
              .executeAction('potvrdiDodavanjePojavnogZaIzlucivanje', {
                $selected: jedinice,
                $parentId: new ItemInfo(parent).id
              })
              .pipe(
                tap(() => {
                  const message =
                    jedinice.length > 1
                      ? 'Pojavni oblici uspješno dodani'
                      : 'Pojavni oblik uspješno dodan';
                  this.notificationService.success(message);
                  this.listviewProvider.refresh();
                }),
                catchError((e) => {
                  const errorMessage =
                    jedinice.length > 1
                      ? 'Greška pri dodavanju pojavnih oblika'
                      : 'Greška pri dodavanju pojavnog oblika';
                  this.notificationService.error(errorMessage);
                  throw e;
                }),
                finalize(() => {
                  this.showDialog = false;
                })
              );
          })
        )
        .subscribe()
    );
  }

  override execute(): void {
    this.showDialog = true;
  }
}
